<template>
    <div :class="$style.unauthorized">
        <Spin size="large"
              fix
              v-if="isLogingOut"></Spin>
        <div :class="$style['unauthorized-content']">
            <div :class="$style['unauthorized-icon']">
                <img src="//awp-assets.meituan.net/hfe/fep/a76da17f268c522891943db9cb3aa8e9/3funauthorized.svg" />
            </div>
            <div :class="$style['unauthorized-info']">
                <p>
                    尊敬的商家：
                </p>
                <p :class="$style.content">
                    抱歉，您没有访问该页面的权限！
                </p>
                <p :class="$style.content">
                    如果您已是三方商家，请联系自己的业务经理咨询解决，谢谢合作！
                </p>
                <button :class="[$style.btn, $style['btn-warning']]"
                        @click="backtoHomePage">返回首页</button>
                <button :class="[$style.btn,$style['btn-primary']]"
                        @click='logout'
                        :disabled='isLogingOut'>
                    退出登录
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from "vuex";
    export default {
        data: function () {
            return {
                isLogingOut: false
            };
        },
        methods: {
            ...mapActions(["doLogout"]),
            error(message) {
                this.$Modal.error({
                    title: "提示",
                    content: message
                });
            },
            logout() {
                this.isLogingOut = true;
                this.doLogout()
                    .then(() => {
                        this.$router.push({ name: "login" });
                        this.isLogingOut = false;
                    })
                    .catch(err => {
                        let msg = (err && err.message) || "登出失败";
                        this.error(msg);
                        this.isLogingOut = false;
                    });
            },
            backtoHomePage() {
                this.$router.push({ name: "newHome" });
            }
        }
    };
</script>

<style lang="postcss" module>
    .unauthorized {
      user-select: none;
      background-color: #e9ecf2;
      position: fixed;
      height: 100%;
      width: 100%;
      .unauthorized-content {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .unauthorized-icon {
          text-align: center;
          margin-bottom: -100px;
        }
        .unauthorized-info {
          background-color: #fff;
          width: 500px;
          color: #666;
          padding: 100px 24px 24px;
          box-shadow: 0 1px 4px 0 hsla(0, 0%, 73%, 0.35);
          border-radius: 4px;
          .content {
            text-indent: 2em;
          }
          .btn {
            width: 100%;
            display: inline-block;
            white-space: nowrap;
            padding: 9px 13px;
            font-size: 14px;
            line-height: 1.42857;
            border-radius: 2px;
            min-width: 50px;
            margin-bottom: 0;
            font-weight: 400;
            text-align: center;
            vertical-align: middle;
            touch-action: manipulation;
            cursor: pointer;
            margin-top: 10px;
            background-image: none;
            color: #fff;
            background-color: #3dc6b6;
            border: 1px solid #3dc6b6;
          }
          .btn.btn-warning {
            background-color: #ff8900;
            border: 1px solid #ff8900;
          }
          .btn.btn-warning:hover {
            background-color: #e67b00;
          }
          .btn:hover {
            color: #fff;
            background-color: #35b4a6;
          }
          .btn:active {
            color: #fff;
            background-color: #2fa194;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// Main.vue?84305562